import { Alert } from '@tempmee/react';
import { pluralize } from '~/utils/String';

interface ICompetingOffersAlertProps {
  /** Number of competing (time-overlapping) offers the professional holds. */
  count?: number;
}

/**
 * Nudges the office to confirm faster by surfacing how many competing offers
 * the professional currently holds. Renders nothing when there are none.
 */
export const CompetingOffersAlert = ({ count = 0 }: ICompetingOffersAlertProps) => {
  if (count <= 0) return null;

  return (
    <Alert
      data-testid="competing-offers-alert"
      data-cy="competing-offers-alert"
      severity="info"
      description={
        <>
          Confirm now to secure coverage.
          <br />
          {`Professional has applied to ${count} other ${pluralize(
            'shift',
            count,
          )} the same day.`}
        </>
      }
    />
  );
};
